import { __awaiter, __decorate, __metadata } from "tslib";
import { Mutation, Action, VuexModule, Module } from 'vuex-module-decorators';
import ApiService from '@/core/services/ApiService';
let CrfModule = class CrfModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.isLoading = false;
        this.xtokenModule = '';
        this.listArrayCrf = [];
        this.filterList = [];
    }
    get getFilterList() {
        return this.filterList;
    }
    get getListCrf() {
        return this.listArrayCrf;
    }
    ['setXtokenModule'](data) {
        this.xtokenModule = data;
    }
    ['setFilterList'](data) {
        this.filterList = data;
    }
    ['setListCrfClear']() {
        this.listArrayCrf = [];
    }
    ['setListCrf'](data) {
        this.listArrayCrf = data;
    }
    ['getListCrfModule'](params) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-crf/api/crf/Monitoring/Multifilter?ver=v1`;
            const parameter = {
                pagingParameter: {
                    pageNumber: params.page,
                    pageSize: params.pageSize,
                    orderColumn: params.orderColumn,
                    orderDir: params.orderDir
                },
                globalSearch: params.globalSearch,
                userLogin: String(params.employeeId),
                pageFilter: params.pageFilter
            };
            return yield new Promise((resolve, reject) => {
                ApiService.post(apiUrl, parameter)
                    .then((response) => {
                    const axiosResponse = response.data.result.content;
                    const users = axiosResponse;
                    this.context.commit('setListCrf', users);
                    this.context.commit('setIsLoading', false);
                    resolve();
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        });
    }
    ['downloadExcelCrfList'](params) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-crf/api/crf/download/excel?ver=v1`;
            const parameter = {
                pagingParameter: {
                    pageNumber: params.page,
                    pageSize: params.pageSize,
                    orderColumn: params.orderColumn,
                    orderDir: params.orderDir
                },
                globalSearch: params.globalSearch,
                userLogin: String(params.employeeId),
                pageFilter: params.pageFilter
            };
            return yield new Promise((resolve, reject) => {
                ApiService.post(apiUrl, parameter)
                    .then((response) => {
                    window.open(response.data.result.content, '_self', 'download');
                })
                    .catch((error) => {
                    reject(error);
                });
                resolve();
            });
        });
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setXtokenModule', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setFilterList', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setListCrfClear', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setListCrf', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], CrfModule.prototype, 'getListCrfModule', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], CrfModule.prototype, 'downloadExcelCrfList', null);
CrfModule = __decorate([
    Module
], CrfModule);
export default CrfModule;
